// ticket #217: Dev / User view toggle.
//
// USER view (default, ALWAYS default) = the clean product a real user sees: dev/QA artifacts
// (the "Recent" QA-fixture teeup list, this toggle itself) are hidden.
// DEV view = everything visible, unchanged from today's build.
//
// This is intentionally NOT a full RBAC system (out of scope per ticket) -- the toggle CONTROL
// is only rendered for a minimal gate: the dev backend deploy (app-dev.coowe.com, mirrors the
// existing isDevBackend() pattern used for showAiFeature/CREATE-AI-V1) OR a small known allowlist
// of internal emails, so a real end user never even sees the switch. Once granted, the chosen mode
// persists in localStorage (mirrors coowe.aiEnabled) and is per-browser, not per-account.

import { isDevBackend } from "@utils/devBackendShim"

const MODE_KEY = "coowe.viewMode" // "user" | "dev"
export const VIEW_MODE_EVENT = "coowe:viewmode-changed"

// Kept minimal and explicit per ticket scope -- extend this array only, never build out a
// permissions system for it.
const DEV_ALLOWLIST = [
  "quentin@coowe.com",
  "quinn.qa@coowe.com",
  "sean@coowe.com",
  "aleksei@coowe.com",
]

export const canSeeViewToggle = userEmail => {
  if (isDevBackend()) return true
  if (!userEmail) return false
  return DEV_ALLOWLIST.includes(String(userEmail).toLowerCase())
}

export const getViewMode = () => {
  try {
    const v = window.localStorage.getItem(MODE_KEY)
    return v === "dev" ? "dev" : "user" // unknown/missing -> USER, always
  } catch {
    return "user"
  }
}

export const isUserView = () => getViewMode() === "user"

export const setViewMode = mode => {
  const next = mode === "dev" ? "dev" : "user"
  try {
    window.localStorage.setItem(MODE_KEY, next)
    window.dispatchEvent(new Event(VIEW_MODE_EVENT))
  } catch {
    /* best-effort */
  }
}
